import dayjs, { Dayjs } from 'dayjs';

const parseDate = (date: string | null | undefined | Dayjs): Dayjs | string => {
  const newDate = dayjs(date, ['MM/DD/YYYY', 'YYYY-MM-DD']);
  if (newDate.isValid()) {
    return newDate;
  }
  return 'Not a valid date';
};

export default parseDate;
